import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { TokenStorage } from '../auth/token.storage';
import { LoginService } from '../../services/login.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const token = inject(TokenStorage).getToken();
    const authenticatedReq = token
        ? req.clone({ setHeaders: { Authorization: `JWT ${token}` } })
        : req;

    return next(authenticatedReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                inject(LoginService).logout();
                inject(Router).navigate(['/home/login']);
            }
            return throwError(() => error);
        })
    );
};
